import { DragDropContext, Droppable } from "@hello-pangea/dnd"
import { RandomId, StringHelper, warn } from "@swivl-mono/helpers"
import { NodeInterface } from "@swivl-mono/types"
import { Checkbox, Switch } from "@swivl-mono/ui"
import anchorme from "anchorme"
import _ from "lodash"
import { useEffect, useMemo } from "react"
import { TagInput } from "../../../../Components/TagInput/TagInput"
import { BrainsModel } from "../../../../Models/Brains/Brains.Model"
import NLPModel from "../../../../Models/NLP/NLP.Model"
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData"
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent"
import InspectorButton from "../SidePanel/Inspector/components/InspectorButton"
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter"
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader"
import NodeActionsHelper from "./Helper/NodeActionsHelper"
import NodePanel from "./NodePanel"
import { CheckedState } from "@radix-ui/react-checkbox"

const Buttons = {
  Type: "buttons",
  Empty: function () {
    let yes = NodeActionsHelper.quickReply("Yes")
    yes.intent = "Affirmation"

    let no = NodeActionsHelper.quickReply("No")
    no.intent = "Negation"

    let node = {
      "id": RandomId(6),
      "type": Buttons.Type,
      "text": "",
      "actionsType": "reply",
      "delay": 0.5,
      "showTyping": true,
      "buttonStyle": "stacked",
      "actions": [yes, no],
    }

    return node;
  },

  PlumbData: function (node: NodeInterface) {
    var tabs: any = [];

    for (var i = 0; i < node.actions.length; i++) {
      let action = node.actions[i];
      tabs.push({
        "id": "actions_" + action.id,
        "source": "actions_" + i + "_onSelectGoto",
        "target": action.onSelectGoto,
        "title": action.text,
      })
    }

    if (node.unhandledOutput) {
      tabs.push({
        "id": "unhandledOutput",
        "source": "unhandledOutput_goto",
        "target": node.unhandledOutput.goto,
        "title": "Unhandled",
      })
    }

    return TabNodeLayoutData({
      node: node,
      body: node.text ? StringHelper.trimStringToLengthWithElipsis(node.text, 70) : "",
      bodyHeight: 40,
      baseWidth: 150,
      tabs: tabs
    });
  },
  isInvald: function (node: NodeInterface) {
    if (!node.text || !node.text.length) {
      return { node: node, issue: "Text is required" };
    }
    return undefined;
  },

  InspectorPanel: function LLMNodeInspectorPanel(props: any) {
    const brains = BrainsModel.useState(s => s.brains)
    const { cachesMap } = NLPModel.useState(state => state);

    const intents = useMemo(() => {
      if (brains && brains.length > 0 && cachesMap) {

        const globalSlug = BrainsModel.getGlobalBrainSlug();
        const globalBrain = brains.find((b: any) => b.slug === globalSlug);


        if (globalBrain && globalBrain.model?.appId && globalBrain.model?.version) {
          const cache = cachesMap[globalBrain.model.appId];
          if (cache) {

            return cache.intents;
          }
        }
      }
    }, [brains, cachesMap])

    useEffect(() => {
      NLPModel.loadCaches()
      BrainsModel.load()
    })
    return <Buttons.InternalInspectorPanel {...props} intents={intents} />
  },

  InternalInspectorPanel: class ButtonsInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.toggleUnhandledOutput = this.toggleUnhandledOutput.bind(this)

      this.onMessageChange = this.onMessageChange.bind(this)
      this.addButton = this.addButton.bind(this)
      this.onDragEnd = this.onDragEnd.bind(this)
    }

    toggleUnhandledOutput(e: any) {
      const on = e.target.value;
      let node = JSON.parse(JSON.stringify(this.props.node));
      if (on) {
        node.unhandledOutput = {
          "id": "unhandledOutput",
          "goto": null,
        }
      } else {
        delete node.unhandledOutput;
      }
      this.props.updateNode(node, this.props.node, true)
    }

    onCheckboxChange(checked: CheckedState, name: string) {
      this.onChange({
        target: {
          name: name,
          value: checked
        }
      });
    }

    onMessageChange(e: any) {
      let node = JSON.parse(JSON.stringify(this.props.node));
      if (!this.props.node.customeDelay) {
        var wordLength = this.props.node.text.split(" ").length;
        if (wordLength > 1) {
          var roundTo = Math.round((wordLength / 6) * 10) / 10;
          if (roundTo > 6) {
            _.set(node, "delay", 6)
          } else if (roundTo < 0.3) {
            _.set(node, "delay", 0.3);
          } else {
            _.set(node, "delay", roundTo.toString());
          }
        } else {
          _.set(node, "delay", 0.3);
        }
      } else {

      }
      _.set(node, 'text', e.target.value);
      this.props.updateNode(node, this.props.node)
    }

    addButton() {
      let buttonId = RandomId(6);
      let buttonData = {
        "id": buttonId,
        "text": "",
        "type": "reply",
        "payload": buttonId,
        "onSelectGoto": null,
        "intent": undefined
      }
      this.addItemToArray(buttonData, "actions", true)
    }

    onDragEnd = (e: any) => {
      if (!e.destination || !e.source || !e.destination.droppableId || !e.source.droppableId || !e.draggableId) { warn("Missing Params"); return; }

      var oldOrder = this.props.node.actions;
      if (e.destination.index >= oldOrder.length) {
        var k = e.destination.index - oldOrder.length + 1;
        while (k--) {
          oldOrder.push(undefined);
        }
      }
      oldOrder.splice(e.destination.index, 0, oldOrder.splice(e.source.index, 1)[0]);
      let node = JSON.parse(JSON.stringify(this.props.node));
      _.set(node, "actions", oldOrder);
      this.props.updateNode(node, this.props.node, true)
      return;
    };

    render() {
      let buttonViews;
      const intents = (this.props as any).intents;
      const intentOptions = (intents) ? [{ id: "NoIntent", value: undefined, label: "No Intent" },
      ...intents.map((i: any) => {

        return { id: i.name, value: i.name, label: i.name }
      })]
        : null;

      const subquests = this.props.node.actions.map((item: any, index: any) => (
        <InspectorButton key={item.id}
          button={item}
          buttons={this.props.node.actions}
          arrayName="actions"
          arrayIndex={index}
          onChange={this.onChange}
          deleteValue={this.deleteValue}
          moveItemInArray={this.moveItemInArray}
          showIntent={true}
          intentOptions={intentOptions}
        />
      ));

      if (this.props.node.actions) {
        buttonViews =
          <Droppable droppableId={"droppable_" + this.props.node.id} type="BUTTON">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={{ backgroundColor: snapshot.isDraggingOver ? '#C3BCB9' : 'transparent', borderRadius: 25, padding: "20px 0" }}
                {...provided.droppableProps}>
                {provided.placeholder}
                {subquests}
              </div>
            )}
          </Droppable>
      }

      var urlTarget;
      if (this.props.node && this.props.node.text) {
        const urlList = anchorme.list(this.props.node.text)  // NOTE: We need to first check to see if it has any urls because if it does, we need to mark the message as having html
        if (urlList && urlList.length > 0) {
          urlTarget = <div className="urlTarget"><span>Open links in new tab</span>
            <Checkbox
              checked={this.props.node.openLinksInNewTab}
              onCheckedChange={(checked) => this.onCheckboxChange(checked, "openLinksInNewTab")}
              name="openLinksInNewTab"
            />
          </div>
        }
      }

      return (
        <DragDropContext onDragEnd={this.onDragEnd}
          onDragStart={(e: any) => {
          }}
        >
          <div>
            <div className="panel button_panel">
              <InspectorNodeHeader title="Buttons" />
              <DelayComponent node={this.props.node} onChange={this.onChange} />
              <span>Message (required)</span>
              <TagInput
                key={"ButtonMessageTextInput_" + this.props.node.id}
                value={this.props.node.text}
                onChange={this.onMessageChange}
                name="text" />
              <div className="variableInfo">To add a variable, type #</div>

              {urlTarget}
              <div className="section">
                <label>Unhandled Output</label>
                <Switch onChange={this.toggleUnhandledOutput} on={(this.props.node.unhandledOutput) ? true : false} />
              </div>
              <label>Buttons</label>

              {buttonViews}
              <div className="addElementButton" onClick={this.addButton} >+ ADD BUTTON</div>
              <div className="carouselPadding">.</div>
            </div>
            <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
          </div>
        </DragDropContext>
      );
    }
  }
}
export default Buttons;
